
import { Vue, Component, Prop } from "vue-property-decorator";
import Booking from "@/domain/booking/Booking";
import InternationalizationService from "@/services/InternationalizationService";
import Table from "@/domain/restaurant/Table";
import TimeService from "@/services/TimeService";
import Room from "@/domain/restaurant/Room";
import BookingOverviewComponent from "@/components/booking/components/BookingOverviewComponent.vue";
import BookingStatusDialog from "@/components/booking/BookingStatusDialog.vue";
import Restaurant from "@/domain/restaurant/Restaurant";
import BookingOverviewComponentTable from "@/components/booking/components/BookingOverviewComponentTable.vue";
@Component({
  components: {
    BookingStatusDialog,
    BookingOverviewComponent,
    BookingOverviewComponentTable
  }
})
export default class BookingOverview extends Vue {
  @Prop({ default: null })
  booking!: Booking;

  @Prop({ default: null })
  table!: Table;

  @Prop({ default: null })
  room!: Room;

  @Prop({ default: false })
  hideActions!: boolean;

  statusDialog = false;

  get tableName() {
    if (this.table != null) return this.table.tableName;
    return this.$t("booking.table.not.selected");
  }

  get roomName() {
    if (this.room != null) return this.room.roomName;
    return this.$t("booking.room.not.selected");
  }

  get languageDisplayString() {
    return InternationalizationService.getDisplayStringFromValue(
      this.booking.language
    );
  }

  get selectedRestaurant(): Restaurant | null {
    return this.$store.getters.getSelectedRestaurant;
  }

  get statusDisplayString() {
    return Booking.getBookingStatusDisplayString(this.booking.status);
  }

  get statusDisplayColour() {
    return Booking.getBookingStatusDisplayColour(this.booking.status);
  }

  getDateTimeDisplayString(isoString: string) {
    return TimeService.getDateTimeDisplayStringFromISO(isoString);
  }

  showStatusDialog() {
    this.statusDialog = true;
  }

  updateBooking(booking: Booking) {
    this.$emit("update-booking", booking);
  }

  get bookingStatusIcon() {
    if (this.selectedRestaurant != null) {
      return this.booking.getBookingStatusIcon().icon;
    }
    return "";
  }

  get bookingStatusIconColour() {
    if (this.selectedRestaurant != null)
      return this.booking.getBookingStatusIcon().colour;
    return "";
  }

  get bookingTableAssignmentIcon() {
    if (this.selectedRestaurant != null)
      return this.booking.getTableAssignmentIcon(this.selectedRestaurant, false)
        .icon;
    return "";
  }

  get bookingTableAssignmentIconColour() {
    if (this.selectedRestaurant != null)
      return this.booking.getTableAssignmentIcon(this.selectedRestaurant, false)
        .colour;
    return "";
  }

  showBookingChangeTableDialog() {
    this.$emit("booking-change-table-dialog", this.booking);
  }
}
